import { Injectable } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { Observable } from 'rxjs/Observable';
import {LogService} from "./logger";

@Injectable()
export class AuthService {
    user: Observable<firebase.User>;
    session: any;

    constructor(
        private firebaseAuth: AngularFireAuth,
        private logService: LogService
    ) {
        //this.user = firebaseAuth.authState;
    }
    getSession()
    {
        if(!this.session)
        {
            //console.log("CREATE NATIVE SESSION");
            this.session = this.firebaseAuth.authState;
            this.session.subscribe(
                (auth) => {
                    if (auth != null) {
                    }
                    else {
                    }
                }
            );
            return this.session;
        }
        else
        {
            //console.log("EXISTING NATIVE SESSION");
            return this.session;
        }
    }
    signup(email: string, password: string) {
        var that = this;
        var promise = this.firebaseAuth
            .auth
            .createUserWithEmailAndPassword(email, password);
        promise.then(value => {
                that.logService.log('Success!', value);
            })
            .catch(err => {
                that.logService.error('Register Error :'+err.message,err);

            });
        return promise;
    }

    login(email: string, password: string) {
        var that = this;
        var promise = this.firebaseAuth
            .auth
            .signInWithEmailAndPassword(email, password);

        promise.then(value => {
                that.logService.log('Logged in!');
            })
            .catch(err => {
                that.logService.error('Login Error :'+err.message,err);
            });
        return promise;
    }

    logout() {
        var that = this;
        var promise = this.firebaseAuth
            .auth
            .signOut();
        promise.then(value => {
            that.logService.log('Registered!');
        })
            .catch(err => {
                that.logService.error('Logout Error :'+err.message,err);
            });
        return promise;
    }

}


// WEBPACK FOOTER //
// ./src/services/auth.ts